export function isPlaceholderHolderEmail(email) {
  return typeof email === "string" && email.toLowerCase().endsWith(".holders.blonix");
}

export function cardholderBlonixId(user) {
  return user?.blonix_id || user?.external_user_id || "—";
}

export function cardholderContactEmail(user) {
  if (!user?.email || isPlaceholderHolderEmail(user.email)) return null;
  return user.email;
}

export function cardholderDisplayName(user) {
  const name = `${user?.first_name || ""} ${user?.last_name || ""}`.trim();
  return name || cardholderBlonixId(user);
}

export function formatCardholderContact(user) {
  return cardholderContactEmail(user) || "—";
}
